import {inject, Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {PermissionsConverter} from '../../../../../../common/converter/permissions.converter';
import {
    PrescriptionMedicineSummaryConverter
} from '../../../../medicine/api/model/converter/prescriptionMedicineSummary.converter';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PrescriptionLineModel} from '../prescriptionLine.model';


@Injectable({providedIn: 'root'})
export class PrescriptionLineConverter extends HttpModelConverter<PrescriptionLineModel>{
    constructor(private prescriptionMedicineSummaryConverter: PrescriptionMedicineSummaryConverter) {
        super();
    }

    protected createInstance(): PrescriptionLineModel {
        return new PrescriptionLineModel();
    }

    protected enrichObject(result: PrescriptionLineModel, src: PrescriptionLineModel) {
        result.permissions = new PermissionsConverter().convert(src.permissions);
        result.medicine = this.prescriptionMedicineSummaryConverter.convert(src.medicine);
    }
}
